/**
 * T2002 · `RegistryContext` — React context providing the `SubjectRegistry`
 * instance to `useRealtimeQuery` and friends.
 *
 * The SDK provider creates ONE registry per `QueryClient` and supplies it
 * through this context. Tests inject a mock registry that satisfies
 * `SubjectRegistryApi`. Consumers MUST be rendered inside a
 * `RegistryContext.Provider` — outside, the wrapper degrades to a plain
 * `useQuery` (no domain pin, no per-entity acquire). The degradation
 * matches server-side / hydration paths where NATS is unavailable.
 */

import { createContext } from 'react';
import type { SubjectRegistryApi } from '../../nats/registry/subject-registry.js';

export const RegistryContext = createContext<SubjectRegistryApi | null>(null);
